import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { Divider } from 'ui-components/common/Divider';
import { ArrowHorizontalIcon } from 'icons/ArrowHorizontalIcon';
import { ReactNode } from 'react';

interface SettingItemProps {
  children?: ReactNode;
  title: string;
  description?: string;
}

export const SettingItem = ({ children, title, description }: SettingItemProps) => (
  <StyledItem>
    <StyledTitleWrapper>
      <StyledTitle>{title}</StyledTitle>
      {description && <StyledDesc>{description}</StyledDesc>}
    </StyledTitleWrapper>
    {children || <ArrowHorizontalIcon direction="right" color={Color.Gray400} />}
    <Divider color={Color.Gray200} />
  </StyledItem>
);

const StyledItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 21px;
  min-height: 57px;
  padding: 16px 0;
`;

const StyledTitleWrapper = styled.div`
  flex-shrink: 0;

  p + p {
    margin-top: 4px;
  }
`;

const StyledTitle = styled.p`
  ${Typography.XSmall};
`;

const StyledDesc = styled.p`
  ${Typography.XXSmall};
  color: ${Color.Gray500};
`;
